import React, { FC } from 'react';
import { Button } from '../../../common/button';


interface IProps {
    onClick: () => void;
}

const UpdatePhotosButton: FC<IProps> = ({ onClick}) => {
    return <Button 
        type='button'
        onClick={() => {
            onClick();
            window.scrollTo(0, 0);
        }}
    >
        Update Photos
    </Button>;
};
export { UpdatePhotosButton };